<template>
  <v-container class="pa-0">
    <v-row>
      <v-col class="pa-0">
        <v-select
          :label="label"
          :items="statuses"
          v-model="selectedStatusId"
          item-value="id"
          item-text="name"
          hide-details
          outlined
          :loading="!isDataFetched"
          :disabled="!isDataFetched"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import _ from 'lodash';

export default {
  name: `InterventionUpdateStatus`,
  props: {
    value: {},
    makerId: {
      type: Number,
      required: false,
    },
    required: {
      type: Boolean,
      default: true,
    },
  },
  data: () => ({
    isDataFetched: false,
    statuses: [],
  }),
  computed: {
    selectedStatusId: {
      get() { return this.value; },
      set(value) {
        const status = _.find(this.statuses, { id: value });
        this.$emit(`change`, status);

        return this.$emit(`input`, value);
      },
    },
    label() {
      let label = `Statut`;
      if (this.required) {
        label = `${label}*`;
      }

      return label;
    },
  },
  async beforeMount() {
    this.isDataFetched = false;
    this.statuses = [];
    if (this.makerId) {
      this.statuses = await this.$store.dispatch(`model/status/fetchListForMaker`, this.makerId);
    } else {
      this.Statuses = await this.$store.dispatch(`model/status/fetchStatuses`);
    }
    this.isDataFetched = true;
  },
};
</script>

<style lang="scss">
</style>
